import React from 'react';
import { useSelector } from 'react-redux';

import { Typography } from 'antd';

import { selectViewOnlyOutlineData } from '../../../../../contentOptimizer/viewOnly/store/viewOnlySettings.selectors';
import { isCurrentOutlineExists } from '../../../../../../../utils/helpers/contentOptimizerHelpers';
import OptimizerBriefOutline from '../../../../contentPage/content/optimizerTab/rightBlock/brief/OptimizerBriefOutline';

const classes = {
    emptyMessage: 'empty-message d-flex flex-center',
    emptyListText: 'empty-list-text',
};

/** Public/shared optimizer page - Outline block */
const OutlineContent = () => {
    const viewOnlyOutlineData = useSelector(selectViewOnlyOutlineData);

    const outlineHtmlData = isCurrentOutlineExists(viewOnlyOutlineData?.outline, true)
        ? viewOnlyOutlineData?.outline
        : null;

    return !!outlineHtmlData ? (
        <OptimizerBriefOutline outlineHtml={outlineHtmlData} sharedPage />
    ) : (
        <div>
            <div className={classes.emptyMessage}>
                <Typography.Text className={classes.emptyListText}>No data</Typography.Text>
            </div>
        </div>
    );
};

export default OutlineContent;
